import { Http, Url } from '@intelipost-js/secure-providers';

export default {
  generateReport({ commit, dispatch }, config) {
    const {
      occurrence,
      date_type,
      dateRange,
      logistic_provider_id,
      delivery_method_id,
    } = config.filters;

    commit('setLoading', true);

    const params = {
      date_type,
      with_clarify_delivery_fail: occurrence,
      delivery_method_id,
    };

    const pathParams = [
      logistic_provider_id || 0,
      dateRange.start,
      dateRange.end,
      config.pagination.limit,
      config.pagination.page,
    ];

    return Http.get(Url.toQueryString('api/v1/report/performance_provider', params, pathParams))
      .then((res) => {
        commit('setReportData', res.data.content);
        commit('setLoading', false);
        return Promise.resolve();
      })
      .then(() => dispatch('generateChartShipmentForState', config))
      .then(() => dispatch('generateChartDeliveredOrders', config))
      .then(() => dispatch('generateChartShipOrders', config))
      .catch(() => commit('setLoading', false));
  },
  generateChartShipmentForState({ commit }, config) {
    const {
      date_type,
      dateRange,
      logistic_provider_id = 1,
      delivery_method_id,
    } = config.filters;

    commit('setLoading', true);

    const params = {
      date_type,
      logistic_provider_id,
      delivery_method_id,
    };

    const pathParams = [
      dateRange.start,
      dateRange.end,
    ];

    return Http.get(Url.toQueryString('api/v1/report/delivered_orders_by_state', params, pathParams)).then((res) => {
      commit('setChartShipmentForState', res.data.content);
      commit('setLoading', false);
    }).catch(() => commit('setLoading', false));
  },
  generateChartDeliveredOrders({ commit }, config) {
    const {
      date_type,
      dateRange,
      logistic_provider_id = 1,
      delivery_method_id,
    } = config.filters;

    commit('setLoading', true);

    const params = {
      date_type,
      logistic_provider_id,
      delivery_method_id,
    };

    const pathParams = [
      dateRange.start,
      dateRange.end,
    ];

    return Http.get(Url.toQueryString('api/v1/report/delivered_orders', params, pathParams)).then((res) => {
      commit('setChartDeliveredOrders', res.data.content);
      commit('setLoading', false);
    }).catch(() => commit('setLoading', false));
  },
  generateChartShipOrders({ commit }, config) {
    const {
      date_type,
      dateRange,
      logistic_provider_id = 1,
      delivery_method_id,
    } = config.filters;

    commit('setLoading', true);

    const params = {
      use_provider_message: 'false',
      date_type,
      delivery_method_id,
    };

    const pathParams = [
      logistic_provider_id,
      dateRange.start,
      dateRange.end,
    ];

    return Http.get(Url.toQueryString('api/v1/report/delivered_orders_with_ocurrence_by_message', params, pathParams)).then((res) => {
      commit('setChartShipOrders', res.data.content);
      commit('setLoading', false);
    }).catch(() => commit('setLoading', false));
  },
  exportPerformanceProviderReport({ commit }, config) {
    const {
      date_type,
      dateRange,
      logistic_provider_id = 1,
      delivery_method_id,
      occurrence,
    } = config.filters;

    commit('setExportLoading', true);

    const params = {
      date_type,
      delivery_method_id,
      with_clarify_delivery_fail: occurrence,
    };

    const pathParams = [
      logistic_provider_id,
      dateRange.start,
      dateRange.end,
    ];

    return Http.get(Url.toQueryString('api/v1/report/performance_provider/excel/v2', params, pathParams)).then(() => {
      commit('setExportLoading', false);
    }).catch(() => commit('setExportLoading', false));
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/reports/pages/provider/store/actions.js